<div class="min-h-screen flex flex-col bg-slate-50">
  <app-metro-toast-banner></app-metro-toast-banner>
  @if (isProcessingExternalLogin) {
  <!-- Pantalla de carga durante el procesamiento del login externo -->
  <div class="min-h-screen flex items-center justify-center bg-slate-50">
    <div class="text-center">
      <div class="mx-auto mb-4"
        style="width: 48px; height: 48px; border: 4px solid rgba(0,0,0,0.1); border-left-color: #4A5568; border-radius: 50%; animation: donut-spin 1.2s linear infinite;">
      </div>
      <p class="text-metro-blue-secondary font-medium">Cargando...</p>
    </div>
  </div>
  } @else if (hasLoggedIn) {
  <!-- Contenido principal debajo del header -->
  <div class="flex flex-col sm:flex-row content-under-header min-h-screen relative">
    <!-- Header de la Aplicación Desktop(de punta a punta) -->
    <app-metro-header [items]="headerItems" [cartCount]="cartCount" (navigate)="onNavigate($event)"
      (action)="onHeaderAction($event)">
    </app-metro-header>
    <!-- Menú de Navegación (debajo del header, a la izquierda) -->
    <app-metro-nav-menu class="w-72 min-h-screen bg-slate-50 hidden sm:block" [items]="navItems"
      [activePath]="currentRoute" (navigate)="onNavigate($event)">
    </app-metro-nav-menu>

    @if (navItemsMobile) {
    <app-mobile-navbar [navItems]="navItemsMobile"></app-mobile-navbar>
    }
    <!-- Área de contenido principal -->
    <main class="flex-1 pb-24 relative min-h-[60vh] flex flex-col">
      <app-mobile-communication-banner *ngIf="hasLoggedIn && !isAdmin"></app-mobile-communication-banner>
      <div class="route-anim-container flex-1" [@routeAnimations]="routeAnimationState">
        <router-outlet #outlet="outlet"></router-outlet>
      </div>
    </main>
  </div>
  } @else {
  <app-metro-public-header [title]="pageTitle"></app-metro-public-header>
  <main class="flex-1 relative min-h-[60vh] flex flex-col" [ngClass]="{'content-under-header': !isLoginPage}">
    <div class="route-anim-container flex-1" [@routeAnimations]="routeAnimationState">
      <router-outlet #publicOutlet="outlet"></router-outlet>
    </div>
  </main>
  }
</div>